// imgproxy 缩略图 URL。签名模式下 URL 由后端(PostgREST 计算列 thumb_url_list/feed(file_info)
// 或视图列 cover_thumb_url_feed / Go 头像)签好;前端不再拼签名(HMAC 密钥不能进浏览器)。
//
// 本函数:优先用后端签好的 URL;为空(无缩略图源)时回退原图直链 /gapi/file/{id}/{name}(无缩放)。

import { resourceUrl } from './resource-node-pref'

export type ThumbPreset = 'list' | 'feed'

/**
 * @param signed   后端签好的缩略图 URL(`/imgp/{sig}/...`);null/undefined → 走 fallback
 * @param baseFileId 源 base_file_id(fallback 用);空 → 返回空串(调用方回退 FileIcon)
 * @param name     源文件名(fallback 拼直链用)
 */
export function thumbUrl(
  signed: string | null | undefined,
  baseFileId: string | null | undefined,
  name: string,
): string {
  if (signed) return resourceUrl(signed)
  if (!baseFileId) return ''
  return resourceUrl(`/gapi/file/${baseFileId}/${encodeURIComponent(name)}`)
}
